/* Vireo coded page — interactions + buy box (replaces Replo runtime + Kaching) */
(function(){
  'use strict';
  if (window.__vireoInit) return; window.__vireoInit = true;

  /* ---------- 0. Kill Kaching's auto-injected buy box (we replaced it) ---------- */
  try { window.kachingBundlesEnabled = false; } catch(e){}
  function killKaching(){
    document.querySelectorAll('kaching-bundle, .kaching-bundles__block, .kaching-bundles-app-block, [id^="kaching-bundles"]').forEach(function(e){
      if (!e.closest('[data-vbx]')) { try { e.remove(); } catch(x){} }
    });
  }
  killKaching();
  try {
    var kmo = new MutationObserver(function(){ killKaching(); });
    kmo.observe(document.documentElement, {childList:true, subtree:true});
    setTimeout(function(){ kmo.disconnect(); killKaching(); }, 6000);
  } catch(e){}

  /* ---------- 1. Accordions (Replo collapsibles) ---------- */
  function initAccordions(){
    document.querySelectorAll('[data-replo-collapsible]').forEach(function(root){
      if (root.__v) return; root.__v = true;
      var trig = root.querySelector('[aria-controls]');
      if (!trig) return;
      var panel = document.getElementById(trig.getAttribute('aria-controls'));
      function set(open){
        root.setAttribute('data-state', open ? 'open' : 'closed');
        trig.setAttribute('aria-expanded', String(open));
        if (panel) { if (open) { panel.hidden = false; } else { panel.hidden = true; } }
      }
      set(root.getAttribute('data-state') === 'open');
      trig.addEventListener('click', function(e){ e.preventDefault(); set(root.getAttribute('data-state') !== 'open'); });
      trig.addEventListener('keydown', function(e){ if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); set(root.getAttribute('data-state') !== 'open'); } });
    });
  }

  /* ---------- 2. Carousels (Replo slide-track) ---------- */
  function initCarousels(){
    document.querySelectorAll('[data-replo-carousel]').forEach(function(car){
      if (car.__v) return; car.__v = true;
      var track = car.querySelector('[data-replo-part="slide-track"]');
      if (!track) return;
      var slides = Array.prototype.filter.call(track.children, function(c){ return c.getAttribute && c.getAttribute('data-replo-part') === 'slide'; });
      if (slides.length < 2) return;
      var prev = car.querySelector('[data-replo-part="nav-button"][data-direction="previous"]');
      var next = car.querySelector('[data-replo-part="nav-button"][data-direction="next"]');
      var idx = 0;
      track.style.transition = 'transform .35s ease';
      track.style.willChange = 'transform';
      function slideW(){ return (slides[1].offsetLeft - slides[0].offsetLeft) || slides[0].getBoundingClientRect().width || 1; }
      function viewport(){ return car.clientWidth || car.getBoundingClientRect().width || slideW(); }
      function perView(){ return Math.max(1, Math.round(viewport() / slideW())); }
      function maxIdx(){ return Math.max(0, slides.length - perView()); }
      function apply(){
        var x = slides[idx].offsetLeft - slides[0].offsetLeft;
        track.style.transform = 'translateX(' + (-x) + 'px)';
        if (prev) prev.disabled = idx <= 0;
        if (next) next.disabled = idx >= maxIdx();
        thumbs.forEach(function(t, i){ t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      }
      function go(d){ idx = Math.min(maxIdx(), Math.max(0, idx + d)); apply(); }
      function set(i){ idx = Math.min(maxIdx(), Math.max(0, i)); apply(); }
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(-1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); go(1); });
      // thumbnails: images inside slides mapped to their index
      var thumbs = slides.map(function(s){ return s; });
      // swipe
      var sx = 0;
      car.addEventListener('touchstart', function(e){ sx = e.touches[0].clientX; }, {passive:true});
      car.addEventListener('touchend', function(e){ var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1); }, {passive:true});
      window.addEventListener('resize', apply);
      car.__setSlide = set; car.__slides = slides;
      apply();
    });
  }

  /* ---------- 2b. Unify fonts: Inter everywhere, weight by size ---------- */
  function unifyFonts(){
    var root = document.getElementById('replo-fullpage-element') || document.getElementById('vireo-fullpage');
    if (!root) return;
    root.querySelectorAll('*').forEach(function(el){
      if (el.closest('.vbx')) return;
      var t = el.tagName;
      if (t === 'IMG' || t === 'SVG' || t === 'PICTURE' || t === 'SOURCE' || t === 'PATH' || t === 'STYLE' || t === 'SCRIPT') return;
      var cs = getComputedStyle(el);
      el.style.setProperty('font-family', "Inter,-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif", 'important');
      var fs = parseFloat(cs.fontSize) || 0;
      el.style.setProperty('font-weight', fs >= 21 ? '700' : '400', 'important');
    });
  }

  /* ---------- 3. Marquee (Replo) — best effort CSS animation ---------- */
  function initMarquees(){
    document.querySelectorAll('[data-replo-marquee],[class*="replo-marquee"]').forEach(function(m){
      if (m.__v) return; m.__v = true;
      // Replo marquees animate an inner strip; ensure it has a width var set
      try {
        var inner = m.querySelector('[class*="marquee"]') || m.firstElementChild;
        if (inner) { m.style.setProperty('--replo-marquee-width', inner.scrollWidth + 'px'); }
      } catch(e){}
    });
  }

  /* ---------- 4. Buy box ---------- */
  var VMAIN = [62642896568650, 62642896601418, 62642896634186];
  var VGIFT = [52982416834890, 51455374557514, 52982531817802]; // sachet, ebook, tbm
  var TIER_ITEMS = {
    1: [{id:62642896568650, quantity:1}],
    2: [{id:62642896601418, quantity:1},{id:52982416834890, quantity:1},{id:51455374557514, quantity:1}],
    3: [{id:62642896634186, quantity:1},{id:52982416834890, quantity:1},{id:51455374557514, quantity:1},{id:52982531817802, quantity:1}]
  };

  function selectTier(vbx, tier){
    vbx.setAttribute('data-tier', tier);
    vbx.querySelectorAll('.vbx-bar').forEach(function(bar){
      bar.classList.toggle('is-sel', bar.getAttribute('data-tier') === String(tier));
      var input = bar.querySelector('input'); if (input) input.checked = bar.getAttribute('data-tier') === String(tier);
    });
    vbx.querySelectorAll('.vbx-gift').forEach(function(g){
      var unlock = parseInt(g.getAttribute('data-unlock') || '99', 10);
      g.classList.toggle('is-locked', tier < unlock);
    });
  }
  function initBuyBoxes(){
    document.querySelectorAll('[data-vbx]').forEach(function(vbx){
      if (vbx.__v) return; vbx.__v = true;
      selectTier(vbx, parseInt(vbx.getAttribute('data-tier') || '2', 10));
      vbx.querySelectorAll('.vbx-bar').forEach(function(bar){
        bar.addEventListener('click', function(e){ e.preventDefault(); selectTier(vbx, parseInt(bar.getAttribute('data-tier'), 10)); });
      });
    });
  }

  function openCart(){
    if (window.ErxCart && window.ErxCart.open) { window.ErxCart.open(); return; }
    ['erxc:open','upcart:open','cart:open'].forEach(function(ev){ document.dispatchEvent(new CustomEvent(ev)); });
  }
  function nearestVbx(btn){
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-vbx]'));
    var pool = all.filter(function(v){ return v.offsetParent !== null && getComputedStyle(v).display !== 'none'; });
    if (!pool.length) pool = all;
    var best = null, bp = -1;
    pool.forEach(function(v){
      if (btn.compareDocumentPosition(v) & Node.DOCUMENT_POSITION_PRECEDING) {
        var d = v.getBoundingClientRect().top;
        if (d > bp) { bp = d; best = v; }
      }
    });
    return best || pool[0];
  }
  var busy = false;
  function addBundle(vbx, btn){
    if (busy) return; busy = true;
    var tier = parseInt(vbx.getAttribute('data-tier') || '2', 10);
    var items = TIER_ITEMS[tier] || TIER_ITEMS[2];
    if (btn) { btn.style.opacity = '.6'; btn.style.pointerEvents = 'none'; }
    fetch('/cart.js', {headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(cart){
      var updates = {};
      cart.items.forEach(function(it){ if (VMAIN.indexOf(it.id) >= 0 || VGIFT.indexOf(it.id) >= 0) updates[it.key] = 0; });
      var p = Object.keys(updates).length ? fetch('/cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({updates: updates})}) : Promise.resolve();
      return p;
    }).then(function(){
      return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({items: items})});
    }).then(function(r){ return r.json(); }).then(function(){
      busy = false; if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; }
      openCart();
    }).catch(function(){ busy = false; if (btn) { btn.style.opacity = ''; btn.style.pointerEvents = ''; } });
  }
  function initATC(){
    document.querySelectorAll('[data-replo-add-product-variant-to-cart]').forEach(function(btn){
      if (btn.__v) return; btn.__v = true;
      btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); addBundle(nearestVbx(btn), btn); }, true);
    });
  }

  /* ---------- 4b. Sync offer label from the top banner (gp-banner) ---------- */
  function syncOffer(){
    var b = document.querySelector('.gpb-offer b');
    var txt = b ? b.textContent.trim() : '';
    if (!txt) return;
    document.querySelectorAll('[data-vbx-offer]').forEach(function(e){ e.textContent = txt; });
  }

  /* ---------- 5. Countdown to local midnight (matches banner: end of local day) ---------- */
  function tick(){
    var now = new Date();
    var end = new Date(); end.setHours(23, 59, 59, 999);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var hh = String(Math.floor(s / 3600)).padStart(2, '0');
    var mm = String(Math.floor((s % 3600) / 60)).padStart(2, '0');
    var ss = String(s % 60).padStart(2, '0');
    var txt = hh + ':' + mm + ':' + ss;
    document.querySelectorAll('[data-vbx-clock]').forEach(function(el){ el.textContent = txt; });
  }

  function initAll(){ initAccordions(); initCarousels(); initMarquees(); initBuyBoxes(); initATC(); unifyFonts(); syncOffer(); tick(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  setInterval(tick, 1000);
  // re-scan shortly after load for any late DOM
  setTimeout(initAll, 800);
})();
